import type { Slider } from '@sshop/domain';

import { parseDto } from '../../mappers/parseDto';
import type { Transport } from '../../transport/Transport';

import { sliderListDto, type SliderDto } from './slider.dto';

export interface SliderService {
  list(signal?: AbortSignal): Promise<readonly Slider[]>;
}

function toSlider(dto: SliderDto): Slider {
  return {
    id: dto.id,
    title: dto.title,
    subtitle: dto.subtitle,
    description: dto.description,
    ctaLabel: dto.cta_label,
    backgroundColor: dto.background_color,
    displayMode: dto.display_mode,
    copyXDesktop: dto.copy_x_desktop,
    copyYDesktop: dto.copy_y_desktop,
    copyXMobile: dto.copy_x_mobile,
    copyYMobile: dto.copy_y_mobile,
    imageScaleDesktop: dto.image_scale_desktop,
    heroLayout: dto.hero_layout,
    ctaUrl: dto.cta_url,
    youtubeUrl: dto.youtube_url,
    image: dto.image,
    mobileImage: dto.mobile_image,
  };
}

export function createLaravelSliderService(transport: Transport): SliderService {
  return {
    async list(signal): Promise<readonly Slider[]> {
      const res = await transport.request({
        method: 'GET',
        path: '/sliders',
        ...(signal !== undefined ? { signal } : {}),
      });
      const parsed = parseDto(sliderListDto, res.data, 'GET /sliders');
      return parsed.data.map(toSlider);
    },
  };
}
